import axios from 'axios'
import store from './../store';

export default class NewsService {

    getNews_old() {
        return axios.get('assets/layout/data/news.json').then(res => res.data.data);
    }



    async getNews(num) {
        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/news/get/'+num,
            headers: {
                authorization: store.state.currentUser.token
            },
          

        });
        return res.data;
    }


    async saveNews(info,rich) {
        const res = await axios({
            method: 'post',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/news/save',
            headers: {
                authorization: store.state.currentUser.token
            },
            data: { info, rich}

        });
        return res.data;
    }
    async updateNews(info, rich,id) {
        const res = await axios({
            method: 'put',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/news/update/'+id,
            headers: {
                authorization: store.state.currentUser.token
            },
            data: { info, rich }

        });
        return res.data;
    }
    async deleteNews(id) {
        const res = await axios({
            method: 'delete',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/news/delete/' + id,
            headers: {
                authorization: store.state.currentUser.token
            },
          

        });
        return res.data;
    }

    async loadNews(id) {
        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/news/load/'+id,
            headers: {
                authorization: store.state.currentUser.token
            },

        });
        return res.data[0];
    }


    async seenNews(news_id) {
        const res = await axios({
            method: 'post',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/news/seen',
            headers: {
                authorization: store.state.currentUser.token
            },
            data: { news_id: news_id, user_id: store.state.currentUser.id }

        });
        return res.data[0];
    }

}